<template>
    <div class="card config-section">
        <CardHeader
            title="Campos Adicionais"
            icon="fas fa-plus-circle"
        />
        <div class="card-body">
            <div class="section-form">
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group">
                            <div class="custom-control custom-switch">
                                <input
                                    id="inform_city_on_reservation"
                                    type="checkbox"
                                    class="custom-control-input"
                                    :checked="value.inform_city_on_reservation"
                                    @change="updateField('inform_city_on_reservation', $event.target.checked)"
                                />
                                <label
                                    class="custom-control-label"
                                    for="inform_city_on_reservation"
                                >
                                    <div class="switch-content">
                                        <i class="fas fa-map-marker-alt mr-2"></i>
                                        <div>
                                            <strong>Exibir campos de Cidade e Justificativa</strong>
                                            <small class="d-block text-muted">
                                                Inclui campos adicionais no formulário de reserva
                                            </small>
                                        </div>
                                    </div>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CardHeader from "../../Base/CardHeader.vue";

export default {
    name: 'AdditionalFieldsConfig',
    components: {CardHeader},
    props: {
        value: {type: Object, required: true},
        errors: {type: Object, default: () => ({})}
    },
    methods: {
        updateField(field, newValue) {
            this.$emit('update', field, newValue);
        }
    }
};
</script>

<style scoped>
/* Estilos compartilhados para todos os componentes */
.config-section {
    border: none;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    margin-bottom: 25px;
    overflow: hidden;
}


.card-body {
    padding: 25px 20px;
    background-color: white;
}

.alert-content i {
    margin-top: 2px;
    font-size: 16px;
}

.form-group {
    margin-bottom: 20px;
}

/* Custom Switch */
.custom-control-input:checked ~ .custom-control-label::before {
    background-color: #FE8D18;
    border-color: #FE8D18;
}

.custom-control-label {
    position: relative;
    margin-bottom: 0;
    padding-left: 2rem;
}

.switch-content {
    display: flex;
    align-items: flex-start;
    gap: 8px;
}

.switch-content i {
    margin-top: 2px;
    color: #FE8D18;
}

/* Responsividade */
@media (max-width: 768px) {

    .alert-content i {
        margin-top: 0;
    }

    .switch-content {
        flex-direction: column;
        gap: 4px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Parameters/components/AdditionalFieldsConfig.vue